import { render, staticRenderFns } from "./productIndex.vue?vue&type=template&id=4a96d89b&scoped=true"
import script from "./productIndex.vue?vue&type=script&lang=js"
export * from "./productIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a96d89b",
  null
  
)

export default component.exports